<router-outlet></router-outlet>
<!-- maintenance -->
<div class="maintenance-holder" *ngIf = "isMaintenance">
    <div class="top-logo">
        <div class="logo-img"></div>
    </div>
    <div class="maintenance-inner-holder">
        <div class="maintenance-content">
            <div class="maintenance-img"></div>
            <div class="maintenance-title">We will be back soon!</div>
            <div class="maintenance-desc">We are currently undergoing maintenance to improve your experience.</div>
            <div class="maintenance-desc">It will be back up shortly and thank you for your patience!</div>
        </div>
    </div>
</div>